import { render } from "./AdditionalComments.vue?vue&type=template&id=54817547&ts=true"
import script from "./AdditionalComments.ts?vue&type=script&lang=ts&external"
export * from "./AdditionalComments.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__